// The last step of /signup-confirmation after a confirm that dropped the
// pre-set password (server core/auth-takeover-paths review r3 D4). The fresh
// session is already stored (confirmEmail). With a `password`, set it through
// the single-use token the confirm answer carried
// (sdk.setInitialPassword → POST /auth/set-initial-password); without one
// (Skip), go straight on. Then re-boot signed in. A failed save keeps the
// person on the step with an error, never boots half-done.
export const completeConfirmSignIn = async function completeConfirmSignIn(password) {
  const s = this.state
  if (password) {
    s.update({ savingPassword: true, setPasswordError: null })
    try {
      await this.sdk.setInitialPassword(s.setPasswordToken, password)
    } catch (error) {
      s.update({ savingPassword: false, setPasswordError: error?.message || 'error' })
      return false
    }
  }
  // Re-boot with the stored session (the confirm's fresh tokens).
  // frank-allow FA401 — auth hard reset: boot re-derives the session from the adopted tokens (spaReloadCensus class b)
  window.location.replace('/')
  return true
}
